import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/setMinutes/index.js';

var require$$29 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$29 as default };
